import React from "react";
import { usDateFormat, usCurrency } from "../../../../../utils";
import {
  retrievePayrollDetailsByFileId,
  getFundingTransactionDetailsByPlan,
  getFundingTransactionDetailsByClassification,
} from "../../../../../services";
import { useRequest } from "../../../../../abstracts";
import { AddToolTip } from "../../../../../components";

const PayrollTransactionDetails = ({
  fileId,
  planId,
  classificationCodeId,
  toggle,
}) => {
  const { response: transDetailByFile, loading: isLoading } = useRequest({
    method: retrievePayrollDetailsByFileId,
    payload: fileId,
    defaultResponse: [],
  });

  const { response: transDetailByPlan, loading: isLoading1 } = useRequest({
    method: getFundingTransactionDetailsByPlan,
    payload: { planId: planId, fileId: fileId },
    defaultResponse: [],
  });

  const {
    response: transDetailByClassification,
    loading: isLoading2,
  } = useRequest({
    method: getFundingTransactionDetailsByClassification,
    payload: {
      classificationCodeId: classificationCodeId,
      planId: planId,
      fileId: fileId,
    },
    defaultResponse: [],
  });

  const transDetails =
    classificationCodeId != undefined
      ? transDetailByClassification
      : planId != undefined
      ? transDetailByPlan
      : transDetailByFile;

  return (
    <>
      {transDetails && toggle
        ? transDetails.map((data) => (
            <>
              <div>
                <p className="grey-text ft-12">Plan name</p>
                <p className="black-text ft-14 font-weight-500">
                  {data.planName}
                </p>
              </div>
              {data.payrollTransactions.map((transc) => (
                <>
                  <div>
                    <p className="grey-text ft-12">Pay date</p>
                    <p className="black-text ft-14 font-weight-500">
                      {usDateFormat(transc.payDate)}
                    </p>
                  </div>
                  <div className="payroll-transaction-table-view">
                    <div className="d-flex justify-content-between table-head">
                      <div>Contribution Breakup</div>
                      <div>Amount</div>
                    </div>
                    <div className="table-body">
                      {transc.transactionSourceDetails.map((source) => (
                        <div className="d-flex justify-content-between">
                          <div>{source.sourceName} </div>
                          <div>{usCurrency(source.amount)}</div>
                        </div>
                      ))}
                      <div className="d-flex justify-content-between">
                        <div>Loan Repayment</div>
                        <div>{usCurrency(transc.loanRepayments)}</div>
                      </div>
                      <div className="line-separator" />
                      <div className="d-flex justify-content-between">
                        <div>Total</div>
                        <div>{usCurrency(transc.total)}</div>
                      </div>
                    </div>
                  </div>
                  <div className="border-top" />
                </>
              ))}
            </>
          ))
        : transDetails &&
          transDetails.map((data, i) => (
            <>
              {i == 0 && (
                <div>
                  <p className="grey-text ft-12">Plan name</p>
                  <p className="black-text ft-14 font-weight-500">
                    <AddToolTip name={data.planName} />
                  </p>
                </div>
              )}

              <div>
                <p className="grey-text ft-12">Pay date</p>
                <p className="black-text ft-14 font-weight-500">
                  {usDateFormat(data.payDate)}
                </p>
              </div>
              <div className="payroll-transaction-table-view">
                <div className="d-flex justify-content-between table-head">
                  <div>Contribution Breakup</div>
                  <div>Amount</div>
                </div>
                <div className="table-body">
                  {data.transactionSourceDetails.map((source) => (
                    <div className="d-flex justify-content-between">
                      <div>{source.sourceName} </div>
                      <div>{usCurrency(source.amount)}</div>
                    </div>
                  ))}
                  <div className="d-flex justify-content-between">
                    <div>Loan Repayment</div>
                    <div>{usCurrency(data.loanRepayments)}</div>
                  </div>
                  <div className="line-separator" />
                  <div className="d-flex justify-content-between">
                    <div>Total</div>
                    <div>{usCurrency(data.total)}</div>
                  </div>
                </div>
              </div>
              <div className="border-top" />
            </>
          ))}
    </>
  );
};

export default PayrollTransactionDetails;
